import { RootState } from "@/modules/common";

export const selectBasketProducts = (state: RootState) =>
  state.basket.basket.products.filter(
    prod =>
      !prod.saturdayDelivery &&
      prod.id !== "410d3ef3-a07e-4dff-b2e6-df04747b47e5"
  );
